// refactor asap
export const VUE_ALL_COLUMNS_LABEL = new Map<string, string>([
	['ingress_fr_lrn', 'From LRN'],
	['ingress_to_lrn', 'To LRN'],
	['ingress_raw_duration_ms', 'Calculated Raw Duration'],
	['honeypotCampaign', 'Campaigns']
]);
